import { createStore, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";

import rootReducer from "./reducer";
import { GET_PROCESSED_PAGE_SUCCESS } from "./action";

const actionSanitizer = action =>
  action.type === GET_PROCESSED_PAGE_SUCCESS
    ? { ...action, payload: `${action.payload.length} files` }
    : action;

const stateSanitizer = state =>
  state.pages ? { ...state, pages: `${state.pages.length} files` } : state;

const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        actionSanitizer,
        stateSanitizer
      })
    : compose;

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

export default store;
